export const API_URLS = {
  AUTH: {
    USER_LOGIN: "/login/",
    USER_REGISTER: "/register/",
    USER_LOGOUT: "/logout/",
    ACCEPT_INVITE: "/user/invite/",
    VALIDATE_INVITE: "/user/invite/",
    RESET_PASSWORD: "/reset-password/",
    PASSWORD_RESET_REQUEST: "/auth/password-reset/",
    GOOGLE_LOGIN: "oauth/google-dashboard/",
    LINKEDIN_LOGIN: "oauth/linkedin-dashboard/",
    FORGET_PASSWORD: "forgot-password/",
  },
  PROFILE: {
    UPDATE_PROFILE: "/user/update/",
    GET_PROFILE_DATA: "/user/",
    CUSTOMER_BOOKING_POLICY_UPDATE: "/bookings/settings/update/",
    ADMIN_BOOKING_POLICY_UPDATE: "/bookings/admin/settings/update/",
    GET_ADMIN_BOOKING_POLICY: "/bookings/admin/settings/list",
    GET_EMPLOYEE_BOOKING_POLICY: "/bookings/employee/settings/list",
    EMPLOYEE_BOOKING_POLICY_UPDATE: "/bookings/employee/settings/update/",
    GET_CUSTOMER_BOOKING_POLICY: "/bookings/settings/list",
    UPDATE_PROFILE_LOGO: "/user/upload-logo/",
    INVITE_USER: "/user/invite/",
    CREATE_USER: "/users/",
  },
  CUSTOMER: {
    GET_CUSTOMER_BY_ID: "/customers",
    ADD_CUSTOMER: "/customers",
    UPDATE_CUSTOMER: "/customers",
    GET_CUSTOMER: "/customers/list",
    DELETE_CUSTOMER: "/customers/delete",
    ARCHIVE_CUSTOMER: "/customers/archive",
    ACTIVATE_CUSTOMER: "/customers/activate",
    DEACTIVATE_CUSTOMER: "/customers/deactivate",
    EXPORT_CUSTOMER: "/customers/export/",
    GET_CUSTOMER_STATS: "/customers/statistics",
    RESET_PASSWORD: "/customers/reset-password",
    GET_PAYMENT_METHOD: "/customers/{id}/payment-method/",
    PROMOTE_TO_ADMIN: "/customers",
    GET_FAILED_LOGINS: "/customers/failed-logins",
    GET_FAILED_LOGIN_DETAIL: "/customers/failed-logins/detail",
  },
  TEE_AGENT: {
    CHAT: "/tee-agent/chat/",
    SESSIONS: "/tee-agent/sessions/",
    SESSION_DETAIL: "/tee-agent/sessions",
    EXECUTE_ACTION: "/tee-agent/actions/execute/",
    CAPABILITIES: "/tee-agent/capabilities/",
  },
  OPERATIONS_HOURS: { GET_OPERATIONS_HOURS: "/bookings/business-hours" },

  PRICING_HOURS: {
    GET_PRICING_HOURS: "/bookings/business-hours/prices",
    UPDATE_PRICING_HOURS: "/bookings/business-hours/update-price/",
    PRICING_HOURS_TEMPLATE: "/bookings/business-hours/templates/",
    SIMULATOR_PRICING_HOURS: "/bookings/business-and-simulator-hours/prices/",
    UPDATE_SIMULATOR_PRICING_HOURS:
      "/bookings/business-and-simulator-hours/update-price/",
  },

  BUSSINESS_HOURS: {
    GET_BUSSINESS_HOURS: "/bookings/business-hours",
    UPDATE_BUSSINESS_HOURS: "/bookings/business-hours/update/",
    SPECIAL_DAYS: "/bookings/business-holidays/",
    SPECIAL_DAYS_PRICING: "/bookings/business-holidays/prices/",
  },
  PAYMENT_GATEAWAYS: {
    PAYMENT_GATEAWAYS: "/payment-gateways/",
  },

  BOOKINGS: {
    GET_BOOKING_STATS: "/bookings/statistics",
    GET_BOOKING_HISTORY: "/bookings/",
    CHECK_BOOKINGS: "/bookings/check",
    CREATE_BOOKINGS: "/bookings/",
    GET_BOOKINGS: "/bookings",
    GET_Monthly_BOOKINGS: "/bookings/calendar-view-month-wise",
    CANCEL_BOOKINGS: "/bookings/cancel/",
    CANCEL_BOOKING_BY_ID: "/bookings/{id}/cancel/",
    BOOKINGS_DELETE: "/bookings/delete/",
    GET_CALENDAR_BOOKINGS: "/bookings/calendar-view",
    GET_CALENDAR_VIEW: "/bookings/update-booking-view",
    GET_BOOKINGS_COUNT: "/bookings/count",
    UPDATE_BOOKING: "/bookings/",
    QUICK_BOOKING: "/bookings/quick-booking/",
    EXPORT_BOOKINGS: "/bookings/export/",
    TIMESLOT_PRICING: "/bookings/timeslots",
    BAYS: "/bookings/bays/",
    BLOCK_HOURS: "/bookings/bays/blocked-hours/",
    BLOCK_BAY: "/bookings/bays/blocked-days/",
    BOOKING_AUTO_RESOLVE: "bookings/auto-reassign-booking-bay/",
    EVENT_AUTO_RESOLVE: "bookings/auto-reassign-event-bay/",
    BULK_UNBLOCK_BAY: "/bookings/bays/blocked-hours/bulk-unblock/",
    BLOCK_BAY_INDEFINITELY: "/bookings/bays/indefinite-block/",
    PENDING_TIMER: "/bookings/",
    TRANSFER_PREVIEW: "/bookings/{id}/transfer-preview/",
    TRANSFER_CUSTOMER: "/bookings/{id}/transfer-customer/",
  },
  WAITLIST: {
    GET_WAITLIST_LIST: "/waitlist/",
    GET_WAITLIST_ENTRY: "/waitlist/", // + {id}/
    CREATE_WAITLIST: "/waitlist/",
    UPDATE_WAITLIST: "/waitlist/", // + {id}/
    DELETE_WAITLIST: "/waitlist/", // + {id}/
    REORDER_WAITLIST: "/waitlist/reorder/",
    GET_WAITLIST_STATS: "/waitlist/statistics/",
    EXPORT_WAITLIST: "/waitlist/export/",
    GET_WAITLIST_ACTIVITY: "/waitlist/", // + {id}/activity/
  },


  EVENTS: {
    GET_EVENTS_LIST: "/events",
    GET_EVENT_BY_ID: "/events/",
    CHECK_BAYS: "/events/check-available-bays/",
    GET_CALENDAR_EVENTS: "/events/calendar/",
    CREATE_EVENT: "/events/",
    REGISTER_EVENT: "/events/register/",
    CANCEL_EVENT: "/events/cancel/",
    CANCEL_EVENT_SERIES: "/events/cancel-series/",
    UPDATE_EVENT: "/events/",
    GET_CATEGORIES: "/events/category/",
    EVENT_CATEGORIES: "/events/category/",
    EXPORT_EVENTS_DATA: "/events/export/",
    GET_EVENT_STATS: "/events/statistics",
    NOTIFY_CUSTOMER: "/events/notify-customer/",
    GET_EVENT_TYPES: "/events/types/",
    EXPORT_EVENT_CONTACTS: "/events/contacts-export/",
  },
  NOTIFICATIONS: {
    GET_LATEST_NOTIFICATIONS: "/notifications/",
    DELETE_NOTIFICATIONS: "/notifications/delete",
    MARK_NOTIFICATIONS: "/notifications/mark-viewed",
    // Notification Groups (Admin)
    NOTIFICATION_GROUPS: "/notification-groups/",
    NOTIFICATION_GROUP_DETAIL: "/notification-groups/", // + {id}/
    NOTIFICATION_GROUP_MEMBERS: "/notification-groups/", // + {id}/members/
    NOTIFICATION_GROUP_ADD_MEMBERS: "/notification-groups/", // + {id}/members/add/
    NOTIFICATION_GROUP_REMOVE_MEMBERS: "/notification-groups/", // + {id}/members/remove/
    NOTIFICATION_GROUP_STATS: "/notification-groups/stats/",
    NOTIFICATION_GROUP_AVAILABLE: "/notification-groups/available/",
    NOTIFICATION_GROUP_SYNC: "/notification-groups/sync/",
    // User Notification Groups
    USER_NOTIFICATION_GROUPS: "/user-notification-groups/my-groups/",
    USER_NOTIFICATION_PREFERENCES: "/user-notification-groups/", // + {group_id}/preferences/
  },
  MEMBERSHIP: {
    CREATE_MEMBERSHIP: "/membership-plans/",
    GET_MEMBERSHIP_PLANS: "/membership-plans/",
    UPDATE_MEMBERSHIP: "/membership-plans/",
    EDIT_MEMBERS_LIST: "/customers/list",
    UPDATE_MEMBERS: "/customers/update-membership/",
    CANCEL_MEMBERSHIP: "/membership-plans/",
    CANCEL_MEMBERSHIP_BY_ID: "/memberships/{id}/cancel/",
    DELETE_MEMBERSHIP: "/membership-plans/",
    UPDATE_USER_MEMBERSHIP: "/user-membership-plans/",
    CREATE_USER_MEMBERSHIP: "/user-membership-plans/",
    GET_USER_MEMBERSHIP: "/user-membership-plans/",
    GET_MEMBERSHIP_STATS: "/memberships/statistics/",
    // Season Hours Management
    GET_SEASON_HOURS: (planId: number) => `/membership-plans/${planId}/season-hours/`,
    UPDATE_SEASON_HOURS: (planId: number) => `/membership-plans/${planId}/season-hours/`,
  },
  TRANSACTIONS: {
    GET_TRANSACTIONS: "/transactions/",
    EXPORT_TRANSACTIONS: "/transactions/export/",
    GET_TRANSACTION_NOTES: "/transactions/notes/",
    CREATE_TRANSACTION_NOTE: "/transactions/notes/",
    UPDATE_TRANSACTION_NOTE: "/transactions/notes/",
    DELETE_TRANSACTION_NOTE: "/transactions/notes/",
    GET_TRANSACTION_RECEIPT: "/retrieve-clover-transaction-receipt",
    TRANSACTION_REFUND: "/refund/",
    GET_TRANSACTION_STATS: "/transactions/statistics",
    NOTIFY_TRANSACTION: "/transactions/notify/",
  },
  VENUE: {
    GET_VENUE_SETTINGS: "/bookings/venue/settings/",
    CREATE_VENUE_SETTINGS: "/bookings/venue/settings/",
    UPDATE_VENUE_SETTINGS: "/bookings/venue/settings/",
  },

  LANGUAGE_REGION: {
    CREATE_LANGUAGE_SETTINGS: "/bookings/regional-date/settings/",
    UPDATE_LANGUAGE_SETTINGS: "/bookings/regional-date/settings/",
    GET_LANGUAGE_SETTINGS: "/bookings/regional-date/settings/",
  },
  SUBSCRIBERS: {
    GET_SUBSCRIBERS: "/events/subscribers/",
    CREATE_SUBSCRIBERS: "/events/subscribers/",
    UPDATE_SUBSCRIBERS: "/events/subscribers/",
    DELETE_SUBSCRIBERS: "/events/subscribers/",
  },

  MANAGE_USERS: {
    ADD_USER: "/user/admin-users/",
    UPDATE_USER: "/user/admin-users/",
    DELETE_USER: "/user/admin-users/",
    DOWNGRADE_USER: "/user/admin-users/", // + {id}/downgrade-to-customer/
    GET_USERS: "/user/admin-users/",
    GET_ROLES: "/user/roles/",
    ASSIGN_ROLES: "/user/assign-roles/",
    GROUPED_PERMISSIONS: "/group-permissions/",
    ASSIGN_PERMISSIONS: "/user-permissions/",
    USER_PERMISSIONS: "/user-permissions/",
    // Custom Permission System
    GET_ALL_PERMISSIONS: "/user/permissions/",
    GET_USER_WITH_PERMISSIONS: "/user/admin-users/",
    ASSIGN_USER_PERMISSIONS: "/user/users/",
    // Role-Based System (NEW)
    GET_ROLE_TEMPLATES: "/user/role-templates/",
    GET_ROLE_TEMPLATE_DETAILS: "/user/role-templates/", // + {id}/
    ASSIGN_ROLE_TO_USER: "/user/users/", // + {userId}/role/
    // Permission Groups API (NEW)
    GET_PERMISSION_GROUPS: "/user/permission-groups/",
    GET_ROLE_PERMISSION_GROUPS: "/user/roles/", // + {roleId}/permission-groups/
    UPDATE_ROLE_PERMISSION_GROUPS: "/user/roles/", // + {roleId}/permission-groups/update/
    GET_PERMISSION_GROUP_STATS: "/user/permission-groups/stats/",
    // User Permission Groups API (NEW)
    GET_USER_PERMISSION_GROUPS: "/user/users/", // + {userId}/permission-groups/
    GET_USER_DIRECT_PERMISSION_GROUPS: "/user/users/", // + {userId}/direct-permission-groups/
    UPDATE_USER_PERMISSION_GROUPS: "/user/users/", // + {userId}/permission-groups/update/
  },

  NEWSLETTER: {
    GET_NEWSLETTER: "/subscriptions/newsletter-subscribers",
    DELETE_NEWSLETTER: "/subscriptions/newsletter-subscribers/",
  },

  SUBMISSIONS: {
    CONTACT_FORMS: "subscriptions/contact-forms/",
    EXPORT_CONTACT: "subscriptions/contact-forms/export/",
    EXPORT_NEWSLETTER: "subscriptions/newsletter-subscribers/export/",
    EXPORT_LEAGUES: "subscriptions/league-contact-forms/export/",
    EXPORT_EVENTS: "subscriptions/event-contact-forms/export/",
    LEAGUES: "subscriptions/league-contact-forms/",
    GET_SUBSCRIPTION_STATS: "/subscriptions/statistics/",
    EVENTS: "subscriptions/event-contact-forms/",
  },

  SETTINGS: {
    COUNTRIES: "/settings/countries/",
    STATES: "/settings/states/",
    CITIES: "/settings/cities/",
    TIMEZONES: "/settings/timezones/",
    DATE_FORMATS: "/settings/date-formats/",
    NOTIFICATION_SETTING: "/settings/notifications/",
    SEASONS: "/settings/seasons/",
    SEASONS_VALIDATE_CONTINUITY: "/settings/seasons/validate-continuity/",
    SEASONS_PRICING_MATRIX_PREVIEW: (seasonId: number) =>
      `/settings/seasons/${seasonId}/bays/pricing-matrix/preview/`,
    PRICING_FORMAT: "/settings/pricing-format/",
    SEASON_BUSINESS_HOURS: (seasonId: number) => `/settings/seasons/${seasonId}/hours/`,
    SEASON_BUSINESS_HOURS_DETAIL: (seasonId: number, hoursId: number) => `/settings/seasons/${seasonId}/hours/${hoursId}/`,
    SEASON_DEPARTMENT_HOURS: (seasonId: number) => `/settings/seasons/${seasonId}/department-hours/`,
    SEASON_DEPARTMENT_HOURS_DETAIL: (seasonId: number, hoursId: number) => `/settings/seasons/${seasonId}/department-hours/${hoursId}/`,
    OPERATION_HOURS_DETAIL: (rangeId: number) => `/settings/operation-hours/hours/${rangeId}/`, // Deprecated: use SEASON_BUSINESS_HOURS_DETAIL
    OPERATION_HOURS_WITH_PRICING: "/settings/operation-hours/",
    ADJUSTMENT_TEMPLATE_AVERAGE: "/settings/operation-hours/adjustment-template-average/",
    BAY_HOVER_PRICING: "/settings/seasons/bay-hover-pricing/",
  },

  SPECIAL_DATES: {
    AUTO_DETECT_SEASON: "/seasons/special-dates/auto-detect/",
    GET_SPECIAL_DATES: (seasonId: number) => `/seasons/${seasonId}/special-dates/`,
    CREATE_SPECIAL_DATE: (seasonId: number) => `/seasons/${seasonId}/special-dates/`,
    SPECIAL_DATE_DETAIL: (seasonId: number, specialDateId: number) =>
      `/seasons/${seasonId}/special-dates/${specialDateId}/`,
    COPY_FROM_DATE: (seasonId: number, specialDateId: number) =>
      `/seasons/${seasonId}/special-dates/${specialDateId}/copy-from/`,
  },

  DYNAMIC_PRICING: {
    SEASON_CONFIG: (seasonId: number) => `/settings/seasons/${seasonId}/dynamic-pricing/`,
    WEATHER_CURRENT: "/settings/weather/current/",
    WEATHER_FORECAST: "/settings/weather/forecast/",  // Will be implemented in backend
    DEMAND_PATTERNS: "/settings/demand/patterns/",    // Will be implemented in backend
    DEMAND_HEATMAP: "/settings/demand/heatmap/",
    PRICING_HISTORY: "/settings/dynamic-pricing/history/",
    PRICING_CURRENT_ADJUSTMENTS: "/settings/pricing/current-adjustments/", // Will be implemented
    PRICING_RECALCULATE: "/settings/pricing/recalculate/", // Will be implemented
    DASHBOARD_STATS: "/settings/dashboard/dynamic-pricing/stats/", // Will be implemented
  },

  ANALYTICS: {
    KPI: "v1/analytics/kpis/",
    DAILY_TRENDS: "v1/booking-analytics/daily-trends/",
    HOURLY_HEATMAP: "v1/analytics/hourly-booking-heatmap/",
    BAY_UTILIZATION: "v1/analytics/bay-utilization/",
    SESSION_DURATION: "v1/analytics/session-duration/",
    CUSTOMER_SEGMENTATION: "v1/analytics/customer-segmentation/",
    TOP_CUSTOMERS: "v1/analytics/top-customers/",
    PAYMENT_PERFORMANCE: "v1/analytics/payment-performance/",
    SCHEDULED_REPORTS: "v1/analytics/scheduled-reports/",
    SCHEDULED_REPORT_DETAIL: (id: number) => `v1/analytics/scheduled-reports/${id}/`,
    ADD_RECIPIENT: (id: number) => `v1/analytics/scheduled-reports/${id}/recipients/add/`,
    BULK_ADD_RECIPIENTS: (id: number) => `v1/analytics/scheduled-reports/${id}/recipients/bulk-add/`,
    IMPORT_CSV_RECIPIENTS: (id: number) => `v1/analytics/scheduled-reports/${id}/recipients/import-csv/`,
    REMOVE_RECIPIENT: (id: number, recipientId: number) => `v1/analytics/scheduled-reports/${id}/recipients/${recipientId}/`,
    GET_RECIPIENTS: (id: number) => `v1/analytics/scheduled-reports/${id}/recipients/`,
    REPORT_HISTORY: (id: number) => `v1/analytics/scheduled-reports/${id}/history/`,
    GENERATE_REPORT: (id: number) => `v1/analytics/scheduled-reports/${id}/generate/`,
  },

  LESSONS: {
    COACHES: "/coaches/",
    WEEKLY_HOURS: "/coaches-weekly-hours/",
    SPECIFIC_DATES: "/coaches-calendar-days",
    COACH_SIMULATOR_DISCOUNT: "/coaches/prices/simulator-discount/",
    COACH_PRICES: "/coaches/prices/",
    CHECK_AVAILABILITY: "/coaches/availability/check/",
    CREATE_LESSON_BOOKING: "/lessons/bookings/",
  },

  MEDIA: {
    GET_MEDIA_LIBRARY: "/media-library/",
    UPLOAD_MEDIA: "/media-library/upload/",
  },

  POPUP: {
    // Configuration Management
    GET_POPUPS: "/popup/config/",
    CREATE_POPUP: "/popup/config/",
    GET_POPUP_BY_ID: (id: string) => `/popup/config/${id}/`,
    UPDATE_POPUP: (id: string) => `/popup/config/${id}/`,
    DELETE_POPUP: (id: string) => `/popup/config/${id}/`,
    UPDATE_STATUS: (id: string) => `/popup/config/${id}/status/`,
    DUPLICATE_POPUP: (id: string) => `/popup/config/${id}/duplicate/`,
    // Media Management
    UPLOAD_IMAGE: "/popup/upload/",
    DELETE_IMAGE: (id: string) => `/popup/images/${id}/`,
    // Lead Management
    SUBMIT_FORM: "/popup/submit/",
    GET_LEADS: "/popup/leads/",
    GET_LEAD_BY_ID: (id: string) => `/popup/leads/${id}/`,
    DELETE_LEAD: (id: string) => `/popup/leads/${id}/`,
    EXPORT_LEADS: "/popup/export/",
    // Analytics
    TRACK_EVENT: "/popup/track/",
    GET_ANALYTICS: "/popup/analytics/",
    GET_POPUP_ANALYTICS: (popupId: string) => `/popup/analytics/${popupId}/`,
    GET_AB_ANALYTICS: (groupId: string) => `/popup/analytics/ab-test/${groupId}/`,
    // Widget Delivery
    GET_WIDGET: "/popup/widget.js",
    GET_ACTIVE_POPUPS: "/popup/active/",
  },

  PIN_AUTH: {
    VERIFY_PIN: "/pin-auth/verify/",
    STAFF_LIST: "/pin-auth/staff/",
    STAFF_DETAIL: (id: number) => `/pin-auth/staff/${id}/`,
    RESET_PIN: (id: number) => `/pin-auth/staff/${id}/reset-pin/`,
    VERIFICATION_LOGS: "/pin-auth/logs/",
    USER_PIN: (userId: number) => `/pin-auth/user/${userId}/pin/`,
    CURRENT_USER_STATUS: "/pin-auth/me/status/",
  },

  WEBSITE_VISITORS: "https://plausible.io/api/v2/query",
  BOOKING_ANALYTICS: "/bookings/analytics",
  CONSOLIDATED_CALENDER: "bookings/consolidated/calendar-view-month-wise",

  // Website CMS
  CMS: {
    // Admin endpoints
    GET_CONTENT: "/cms/content/",
    UPDATE_CONTENT: "/cms/content/",
    PUBLISH_CONTENT: "/cms/content/publish/",
    GET_VERSIONS: "/cms/versions/",
    GET_VERSION_DETAIL: (id: number) => `/cms/versions/${id}/`,
    RESTORE_VERSION: (id: number) => `/cms/versions/${id}/restore/`,
    AI_GENERATE: "/cms/ai/generate/",
    // Branding endpoints
    GET_BRANDING: "/settings/branding/",
    UPDATE_BRANDING: "/settings/branding/",
    // Template endpoints
    GET_TEMPLATES: "/cms/templates/",
    GET_ACTIVE_TEMPLATE: "/cms/templates/active/",
    SET_ACTIVE_TEMPLATE: "/cms/templates/active/",
    GET_TEMPLATE_PREVIEW: (templateId: string) => `/cms/templates/${templateId}/preview/`,
  },

  // League Management Module (mounted at /api/leagues/)
  LEAGUES: {
    LEAGUES: "leagues/leagues/",
    LEAGUE_DETAIL: (id: string) => `leagues/leagues/${id}/`,
    SEASONS: "leagues/seasons/",
    SEASON_DETAIL: (id: string) => `leagues/seasons/${id}/`,
    SEASON_STANDINGS: (id: string) => `leagues/seasons/${id}/standings/`,
    EVENTS: "leagues/events/",
    EVENT_DETAIL: (id: string) => `leagues/events/${id}/`,
    EVENT_LEADERBOARD: (id: string) => `leagues/events/${id}/leaderboard/`,
    EVENT_TEAMS: (id: string) => `leagues/events/${id}/teams/`,
    EVENT_PARTICIPANTS: (id: string) => `leagues/events/${id}/participants/`,
    EVENT_PACE: (id: string) => `leagues/events/${id}/pace/`,
    EVENT_SUMMARY: (id: string) => `leagues/events/${id}/summary/`,
    TEAMS: "leagues/teams/",
    TEAM_SCORECARD: (id: string) => `leagues/teams/${id}/scorecard/`,
    SCORES: "leagues/scores/",
    VENUES: "leagues/venues/",
    HOLES: "leagues/holes/",
    POINTS_SYSTEMS: "leagues/points-systems/",
    SEASON_PARTICIPANTS: "leagues/season-participants/",
    EVENT_PARTICIPANTS_LIST: "leagues/event-participants/",
    MULTI_DAY_TOURNAMENTS: "leagues/multi-day-tournaments/",
    MULTI_DAY_TOURNAMENT_DETAIL: (id: string) => `leagues/multi-day-tournaments/${id}/`,
    MULTI_DAY_TOURNAMENT_DAYS: (id: string) => `leagues/multi-day-tournaments/${id}/days/`,
    MULTI_DAY_TOURNAMENT_FLIGHTS: (id: string) => `leagues/multi-day-tournaments/${id}/flights/`,
    FLIGHTS: "leagues/flights/",
    PROFILES: "leagues/profiles/",
    PROFILE_FLAG: (id: string) => `leagues/profiles/${id}/flag/`,
    BROADCASTS: "leagues/broadcasts/",
    BROADCAST_DETAIL: (id: string) => `leagues/broadcasts/${id}/`,
    BROADCAST_SEND: (id: string) => `leagues/broadcasts/${id}/send/`,
    SPONSORSHIP_PACKAGES: "leagues/sponsorship-packages/",
    SPONSORSHIP_PACKAGE_DETAIL: (id: string) => `leagues/sponsorship-packages/${id}/`,
    HOLE_SPONSORS: "leagues/hole-sponsors/",
    HOLE_SPONSOR_DETAIL: (id: string) => `leagues/hole-sponsors/${id}/`,
    SHOP_PRODUCTS: "leagues/shop-products/",
    SHOP_PRODUCT_DETAIL: (id: string) => `leagues/shop-products/${id}/`,
    PRIZE_REDEMPTIONS: "leagues/prize-redemptions/",
    PRIZE_REDEMPTION_DETAIL: (id: string) => `leagues/prize-redemptions/${id}/`,
    PRIZE_REDEMPTION_APPROVE: (id: string) => `leagues/prize-redemptions/${id}/approve/`,
    PRIZE_REDEMPTION_REDEEM: (id: string) => `leagues/prize-redemptions/${id}/redeem/`,
    SIDE_GAMES: "leagues/side-games/",
    SIDE_GAME_DETAIL: (id: string) => `leagues/side-games/${id}/`,
    SIDE_GAME_ENTRIES: "leagues/side-game-entries/",
    CALCUTTA_AUCTIONS: "leagues/calcutta-auctions/",
    CALCUTTA_AUCTION_DETAIL: (id: string) => `leagues/calcutta-auctions/${id}/`,
    CALCUTTA_LOTS: "leagues/calcutta-lots/",
    CALCUTTA_LOT_DETAIL: (id: string) => `leagues/calcutta-lots/${id}/`,
    CALCUTTA_LOT_BID: (id: string) => `leagues/calcutta-lots/${id}/bid/`,
    CALCUTTA_LOT_HAMMER: (id: string) => `leagues/calcutta-lots/${id}/hammer/`,
    NETWORK_SUMMARY: "leagues/leagues/network_summary/",
  },

  // Golf Course Management Module
  // Note: All URLs start with "v1/" not "/api/v1/" because baseURL already includes "/api/"
  GOLF: {
    // Facility Context
    FACILITY_CURRENT: "v1/facility/current/",

    // Golf Courses
    COURSES: "v1/golf/courses/",
    COURSE_DETAIL: (courseId: string) => `v1/golf/courses/${courseId}/`,
    /** Operational shift roles for staff scheduling (per course). */
    COURSE_SHIFT_ROLES: (courseId: string) =>
      `v1/golf/courses/${courseId}/shift-roles/`,
    COURSE_SHIFT_ROLE_DETAIL: (courseId: string, roleId: string) =>
      `v1/golf/courses/${courseId}/shift-roles/${roleId}/`,
    COURSE_SHIFT_ROLES_IMPORT_CLOVER: (courseId: string) =>
      `v1/golf/courses/${courseId}/shift-roles/import-clover/`,

    // Holes
    HOLES: "v1/golf/holes/",
    HOLE_DETAIL: (holeId: string) => `v1/golf/holes/${holeId}/`,
    COURSE_HOLES: (courseId: string) => `v1/golf/courses/${courseId}/holes/`,

    // Tee Boxes
    TEE_BOXES: "v1/golf/tee-boxes/",
    TEE_BOX_DETAIL: (teeBoxId: string) => `v1/golf/tee-boxes/${teeBoxId}/`,
    COURSE_TEE_BOXES: (courseId: string) => `v1/golf/courses/${courseId}/tee-boxes/`,
    /** List/filter: `GET ?tee_box=<uuid>` (see golf_course TeeBoxHoleYardageViewSet). */
    TEE_BOX_YARDAGES: "v1/golf/tee-box-yardages/",

    // Tee Times
    TEE_TIMES: "v1/golf/tee-times/",
    TEE_TIME_DETAIL: (teeTimeId: string) => `v1/golf/tee-times/${teeTimeId}/`,
    TEE_TIMES_CALENDAR: "v1/golf/tee-times/calendar/",
    TEE_TIME_CHECK_IN: (teeTimeId: string) => `v1/golf/tee-times/${teeTimeId}/check-in/`,
    TEE_TIME_CANCEL: (teeTimeId: string) => `v1/golf/tee-times/${teeTimeId}/cancel/`,
    TEE_TIME_NO_SHOW: (teeTimeId: string) => `v1/golf/tee-times/${teeTimeId}/no-show/`,
    TEE_TIME_BLOCK: (teeTimeId: string) => `v1/golf/tee-times/${teeTimeId}/block/`,
    TEE_TIME_UNBLOCK: (teeTimeId: string) => `v1/golf/tee-times/${teeTimeId}/unblock/`,
    TEE_TIME_CONFIG: "v1/golf/tee-time-config/",

    // Carts
    CARTS: "v1/golf/carts/",
    CART_DETAIL: (cartId: string) => `v1/golf/carts/${cartId}/`,
    CART_SET_STATUS: (cartId: string) => `v1/golf/carts/${cartId}/status/`,
    CART_ASSIGNMENTS: "v1/golf/cart-assignments/",
    CART_ASSIGNMENT_DETAIL: (assignmentId: string) => `v1/golf/cart-assignments/${assignmentId}/`,
    CART_ASSIGNMENT_RETURN: (assignmentId: string) => `v1/golf/cart-assignments/${assignmentId}/return/`,
    CART_MAINTENANCE: "v1/golf/cart-maintenance/",
    CART_MAINTENANCE_DETAIL: (logId: string) => `v1/golf/cart-maintenance/${logId}/`,

    // Weather
    WEATHER_CURRENT: "v1/golf/weather/current/",
    WEATHER_FORECAST: "v1/golf/weather/forecast/",
    WEATHER_ALERTS: "v1/golf/weather/alerts/",
    WEATHER_ALERT_ACKNOWLEDGE: (alertId: string) => `v1/golf/weather/alerts/${alertId}/acknowledge/`,
    COURSE_PLAYABILITY: "v1/golf/course-playability/",

    // Dashboard
    DASHBOARD_STATS: "v1/golf/dashboard/stats/",
    DASHBOARD_TEE_SHEET: "v1/golf/dashboard/tee-sheet/",

    // Cart V2: Pace of Play
    PACE_CHECKPOINTS: "v1/golf/pace-checkpoints/",
    PACE_CHECKPOINT_DETAIL: (id: string) => `v1/golf/pace-checkpoints/${id}/`,
    GROUP_PROGRESS: "v1/golf/group-progress/",
    GROUP_PROGRESS_DETAIL: (id: string) => `v1/golf/group-progress/${id}/`,
    PACE_ALERTS: "v1/golf/pace-alerts/",
    PACE_ALERT_DETAIL: (id: string) => `v1/golf/pace-alerts/${id}/`,
    PACE_ALERT_ACKNOWLEDGE: (id: string) => `v1/golf/pace-alerts/${id}/acknowledge/`,
    PACE_ALERT_DISPATCH: (id: string) => `v1/golf/pace-alerts/${id}/dispatch_marshal/`,
    PACE_ALERT_RESOLVE: (id: string) => `v1/golf/pace-alerts/${id}/resolve/`,

    // Cart V2: Beverage Ops
    BEVERAGE_ORDERS: "v1/golf/beverage-orders/",
    BEVERAGE_ORDER_DETAIL: (id: string) => `v1/golf/beverage-orders/${id}/`,
    BEVERAGE_ORDERS_ACTIVE: "v1/golf/beverage-orders/active/",
    BEVERAGE_INVENTORY: "v1/golf/beverage-inventory/",
    BEVERAGE_INVENTORY_DETAIL: (id: string) => `v1/golf/beverage-inventory/${id}/`,
    BEVERAGE_INVENTORY_LOW: "v1/golf/beverage-inventory/low_stock/",
    BEVERAGE_ROUTES: "v1/golf/beverage-routes/",
    BEVERAGE_ROUTE_DETAIL: (id: string) => `v1/golf/beverage-routes/${id}/`,

    // Cart V2: Messaging
    MESSAGE_THREADS: "v1/golf/message-threads/",
    MESSAGE_THREAD_DETAIL: (id: string) => `v1/golf/message-threads/${id}/`,
    MESSAGE_THREAD_MESSAGES: (id: string) => `v1/golf/message-threads/${id}/messages/`,
    MESSAGE_THREAD_SEND: (id: string) => `v1/golf/message-threads/${id}/send/`,
    MESSAGE_THREAD_MARK_READ: (id: string) => `v1/golf/message-threads/${id}/mark_read/`,

    // Cart V2: Telematics & Wash
    FAULT_CODES: "v1/golf/fault-codes/",
    FAULT_CODE_DETAIL: (id: string) => `v1/golf/fault-codes/${id}/`,
    TELEMETRY: "v1/golf/telemetry/",
    TELEMETRY_LATEST: "v1/golf/telemetry/latest/",
    WASH_TEMPLATES: "v1/golf/wash-templates/",
    WASH_TEMPLATE_DETAIL: (id: string) => `v1/golf/wash-templates/${id}/`,
    WASH_SESSIONS: "v1/golf/wash-sessions/",
    WASH_SESSION_DETAIL: (id: string) => `v1/golf/wash-sessions/${id}/`,
    WASH_SESSION_START: (id: string) => `v1/golf/wash-sessions/${id}/start/`,
    WASH_SESSION_COMPLETE: (id: string) => `v1/golf/wash-sessions/${id}/complete/`,

    // Cart V2: Geofencing & PINs
    GEOFENCE_ZONES: "v1/golf/geofence-zones/",
    GEOFENCE_ZONE_DETAIL: (id: string) => `v1/golf/geofence-zones/${id}/`,
    FLEET_POLICIES: "v1/golf/fleet-policies/",
    FLEET_POLICY_DETAIL: (id: string) => `v1/golf/fleet-policies/${id}/`,
    FLEET_POLICY_TOGGLE: (id: string) => `v1/golf/fleet-policies/${id}/toggle/`,
    DRIVER_PINS: "v1/golf/driver-pins/",
    DRIVER_PIN_DETAIL: (id: string) => `v1/golf/driver-pins/${id}/`,
    DRIVER_PIN_ISSUE: "v1/golf/driver-pins/issue/",
    DRIVER_PIN_VERIFY: (id: string) => `v1/golf/driver-pins/${id}/verify/`,
    DRIVER_PIN_DEACTIVATE: (id: string) => `v1/golf/driver-pins/${id}/deactivate/`,
    PIN_AUDIT_LOGS: "v1/golf/pin-audit-logs/",
  },

  // Caddy Management
  CADDY: {
    // Caddies
    CADDIES: "caddy-management/caddies/",
    CADDY_DETAIL: (caddyId: string) => `caddy-management/caddies/${caddyId}/`,

    // Availability
    AVAILABILITY: "caddy-management/availability/",
    AVAILABILITY_DETAIL: (availabilityId: string) => `caddy-management/availability/${availabilityId}/`,
    AVAILABLE_CADDIES: "caddy-management/available/",

    // Assignments
    ASSIGNMENTS: "caddy-management/assignments/",
    ASSIGNMENT_DETAIL: (assignmentId: string) => `caddy-management/assignments/${assignmentId}/`,
    AUTO_ASSIGN: "caddy-management/auto-assign/",

    // Preferences
    PREFERENCES: "caddy-management/preferences/",
    PREFERENCE_DETAIL: (preferenceId: string) => `caddy-management/preferences/${preferenceId}/`,

    // Compensation & Payroll
    COMPENSATIONS: "caddy-management/compensations/",
    COMPENSATION_DETAIL: (compensationId: string) => `caddy-management/compensations/${compensationId}/`,
    PAYROLL: "caddy-management/payroll/",
    PAYROLL_DETAIL: (payrollId: string) => `caddy-management/payroll/${payrollId}/`,

    // Certifications
    CERTIFICATIONS: "caddy-management/certifications/",
    CERTIFICATION_DETAIL: (certificationId: string) => `caddy-management/certifications/${certificationId}/`,
  },

  // Staff Scheduling
  STAFF: {
    // Staff Profiles
    PROFILES: "staff-scheduling/profiles/",
    PROFILE_DETAIL: (profileId: string) => `staff-scheduling/profiles/${profileId}/`,
    PROFILE_CALENDAR: (profileId: string) => `staff-scheduling/profiles/${profileId}/calendar/`,
    PROFILE_SCHEDULE: (profileId: string) => `staff-scheduling/profiles/${profileId}/schedule/`,
    PROFILE_OVERRIDES: (profileId: string) => `staff-scheduling/profiles/${profileId}/overrides/`,
    PROFILE_ASSIGNMENTS: (profileId: string) => `staff-scheduling/profiles/${profileId}/assignments/`,

    // Schedule Templates
    TEMPLATES: "staff-scheduling/templates/",
    TEMPLATE_DETAIL: (templateId: string) => `staff-scheduling/templates/${templateId}/`,
    BULK_TEMPLATES: "staff-scheduling/templates/bulk/",

    // Schedule Overrides
    OVERRIDES: "staff-scheduling/overrides/",
    OVERRIDE_DETAIL: (overrideId: string) => `staff-scheduling/overrides/${overrideId}/`,
    OVERRIDE_REVIEW: (overrideId: string) => `staff-scheduling/overrides/${overrideId}/review/`,

    // Assignments
    ASSIGNMENTS: "staff-scheduling/assignments/",
    ASSIGNMENT_DETAIL: (assignmentId: string) => `staff-scheduling/assignments/${assignmentId}/`,

    // Availability & Auto-assign
    AVAILABILITY: "staff-scheduling/availability/",
    AUTO_ASSIGN: "staff-scheduling/auto-assign/",

    // Shifts (per-date scheduled shifts)
    SHIFTS: "staff-scheduling/shifts/",
    SHIFT_DETAIL: (shiftId: string) => `staff-scheduling/shifts/${shiftId}/`,
    SHIFTS_PUBLISH: "staff-scheduling/shifts/publish/",
    SHIFTS_COPY_WEEK: "staff-scheduling/shifts/copy-week/",
    SHIFTS_CLEAR_WEEK: "staff-scheduling/shifts/clear-week/",

    // Open Shifts
    OPEN_SHIFTS: "staff-scheduling/open-shifts/",
    OPEN_SHIFT_DETAIL: (shiftId: string) => `staff-scheduling/open-shifts/${shiftId}/`,
    OPEN_SHIFT_CLAIM: (shiftId: string) => `staff-scheduling/open-shifts/${shiftId}/claim/`,
    OPEN_SHIFT_APPROVE: (shiftId: string) => `staff-scheduling/open-shifts/${shiftId}/approve/`,
    OPEN_SHIFT_DENY: (shiftId: string) => `staff-scheduling/open-shifts/${shiftId}/deny/`,
    OPEN_SHIFT_NOTIFY: (shiftId: string) => `staff-scheduling/open-shifts/${shiftId}/notify/`,
  },

  // Payroll Sync module (Employee Hours, Rates & Payroll)
  PAYROLL: {
    PERIOD: "staff-scheduling/payroll/period/",
    EMPLOYEE_DETAIL: (employeeId: string) => `staff-scheduling/payroll/employee/${employeeId}/`,
    EXPORT: "staff-scheduling/payroll/export/",
    IMPORT_RATES: "staff-scheduling/payroll/import-rates/",
    BULK_EDIT: "staff-scheduling/payroll/bulk-edit/",
    SYNC_STATUS: "staff-scheduling/payroll/sync-status/",
    PAY_RATES: "staff-scheduling/pay-rates/",
    PAY_RATE_DETAIL: (id: string) => `staff-scheduling/pay-rates/${id}/`,
    HOURS: "staff-scheduling/hours/",
    HOUR_DETAIL: (id: string) => `staff-scheduling/hours/${id}/`,
    ROLE_MAPPINGS: "staff-scheduling/role-mappings/",
    ROLE_MAPPING_DETAIL: (id: string) => `staff-scheduling/role-mappings/${id}/`,
    ROLE_MAPPINGS_UNMAPPED: "staff-scheduling/role-mappings/unmapped/",
    CANONICAL_EMPLOYEES: "staff-scheduling/canonical-employees/",
    SYNC_RUNS: "staff-scheduling/sync-runs/",
    // Homebase hours in, Gusto payroll out
    IMPORT_HOURS: "staff-scheduling/payroll/import-hours/",
    GUSTO_PUSH: "staff-scheduling/payroll/gusto-push/",
    NAME_ALIASES: "staff-scheduling/payroll/name-aliases/",
  },

  // Unified Scheduling (Admin Users)
  SCHEDULING: {
    WEEKLY_HOURS: "admin-users/weekly-hours/",
    CALENDAR_DAYS: "admin-users/calendar-days/",
    CALENDAR_DAY_DELETE: (id: number) => `admin-users/calendar-days/${id}/`,
    CHECK_AVAILABILITY: "admin-users/availability/check/",
  },

  // New Caddies Module (Coach Pattern)
  NEW_CADDY: {
    CADDIES: "caddies/",
    CADDY_DETAIL: (id: number) => `caddies/${id}/`,
    WEEKLY_HOURS: "caddies-weekly-hours/",
    CALENDAR_DAYS: "caddies-calendar-days/",
    CALENDAR_DAY_DELETE: (id: number) => `caddies-calendar-days/${id}/`,
    CHECK_AVAILABILITY: "caddies/availability/check/",
    ASSIGNMENTS: "caddy-assignments/",
    ASSIGNMENT_DETAIL: (id: number) => `caddy-assignments/${id}/`,
    STATS: "caddies/stats/",
  },

  // POS (Point of Sale)
  POS: {
    CATEGORIES: "pos/categories/",
    PRODUCTS: "pos/products/",
    PRODUCT_DETAIL: (id: number) => `pos/products/${id}/`,
    ORDERS: "pos/orders/",
    ORDER_DETAIL: (id: number) => `pos/orders/${id}/`,
    ORDER_ADD_LINE: (id: number) => `pos/orders/${id}/add-line/`,
    ORDER_COMPLETE: (id: number) => `pos/orders/${id}/complete/`,
    ORDER_REFUND: (id: number) => `pos/orders/${id}/refund/`,
    ORDER_DISCOUNT: (id: number) => `pos/orders/${id}/discount/`,
    RECENT_ORDERS: "pos/orders/recent/",
    STATISTICS: "pos/statistics/",
    SETTINGS: "pos/settings/",
    TABS: "pos/tabs/",
    TAB_DETAIL: (id: number) => `pos/tabs/${id}/`,
    TAB_SETTLE: (id: number) => `pos/tabs/${id}/settle/`,
    MODIFIER_GROUPS: "pos/modifier-groups/",
    MODIFIER_GROUP_DETAIL: (id: number) => `pos/modifier-groups/${id}/`,
    PRINTERS: "pos/printers/",
    PRINTER_DETAIL: (id: number) => `pos/printers/${id}/`,
    TAX_RATES: "pos/tax-rates/",
    CLOVER_SYNC: "pos/clover-sync/",
    FLOOR_PLANS: "pos/floor-plans/",
    FLOOR_PLAN_DETAIL: (id: number) => `pos/floor-plans/${id}/`,
    FLOOR_TABLES: "pos/floor-tables/",
    FLOOR_TABLE_DETAIL: (id: number) => `pos/floor-tables/${id}/`,
  },

  CLOVER: {
    STATUS: "clover/status/",
    REPORT_SALES: "clover/reports/sales/",
    REPORT_TIPS: "clover/reports/tips/",
    REPORT_CASH_DRAWER: "clover/reports/cash-drawer/",
    REPORT_ALCOHOL_TIPOUT: "clover/reports/alcohol-tipout/",
    REPORT_STAFFING: "clover/reports/staffing/",
    REPORT_STAFFING_HEATMAP: "clover/reports/staffing-heatmap/",
    STAFFING_SCHEDULE: "clover/reports/staffing-schedule/",
    HOURLY_COST_COVERAGE: "clover/reports/hourly-cost-coverage/",
    EMPLOYEES: "clover/employees/",
  },

  TIPOUT: {
    RULES: "tipout/rules/",
    RULE_DETAIL: (id: number) => `tipout/rules/${id}/`,
    RUNS: "tipout/runs/",
    RUN_DETAIL: (id: number) => `tipout/runs/${id}/`,
    RUN_APPROVE: (id: number) => `tipout/runs/${id}/approve/`,
    POOLS: "tipout/pools/",
    POOL_DETAIL: (id: number) => `tipout/pools/${id}/`,
    POOL_PAYOUTS: "tipout/pool-payouts/",
    POOL_PAYOUT_SEND: (id: number) => `tipout/pool-payouts/${id}/send/`,
    SMS_CONFIG: "tipout/sms-config/",
  },
};
